import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Dog: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_382)">
                <IconPath
                    d="M6.96624 21.537H4.03124C3.35827 18.6373 2.86831 15.6982 2.56424 12.737C2.56385 12.255 2.65843 11.7777 2.84257 11.3322C3.02672 10.8868 3.29682 10.482 3.63745 10.141C3.97809 9.80004 4.38257 9.52949 4.82779 9.34486C5.27301 9.16023 5.75025 9.06513 6.23224 9.065H12.8322C13.1807 9.09358 13.5301 9.02302 13.8401 8.86146C14.1501 8.69991 14.4081 8.45395 14.5842 8.152M17.2372 5.764C17.2372 7.182 17.6042 8.332 15.7692 8.332C13.9342 8.332 13.5682 7.6 14.3002 5.4C14.7472 4.06 15.1702 2.466 17.9682 2.466C18.6213 2.49752 19.2499 2.72393 19.773 3.11606C20.2961 3.50819 20.6898 4.04804 20.9032 4.666L23.1032 5.399C23.1032 5.399 23.9282 9.48 20.1682 9.067C19.4352 12.002 20.1682 14.203 17.9682 15.667V21.536H19.4362M10.6342 13.467C10.6342 13.467 10.6342 16.402 6.96624 16.402L6.11024 21.537M17.9702 21.537H15.0362L14.3022 15.668H12.8352M3.30024 10.533C3.30024 10.533 -0.370757 9.8 1.10024 5.4"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_382">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
